import type { MouseEvent, TouchEvent, KeyboardEvent } from 'react';

const LEFT_MOUSE_BUTTON = 0;
const ENTER = 'Enter';
const SPACE = 'Space';

/**
 * Enables detecting the beginning of a probable click in a mousedown,
 * touchstart or keydown event. There is no guarantee that the click event
 * will follow - it could be cancelled, but probable.
 *
 * Note: using a pointerdown events won't trigger click events on iOS.
 */
export const isButtonClickStarted = (
    event: MouseEvent | TouchEvent | KeyboardEvent,
): boolean => {
    const { type } = event;

    const isMouseClick =
        type === 'mousedown' &&
        (event as MouseEvent).button === LEFT_MOUSE_BUTTON;
    const isSingleTouch =
        type === 'touchstart' && (event as TouchEvent).touches.length === 1;
    const isKeyboardClick =
        type === 'keydown' &&
        [ENTER, SPACE].includes((event as KeyboardEvent).code);

    return isMouseClick || isSingleTouch || isKeyboardClick;
};
